/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

var $ = require('jquery');

function jqueryRequest(method, url, args) {
  var deferred = $.Deferred();
  $.ajax({
    type: method,
    url: url,
    headers: args.headers,
    data: JSON.stringify(args.data),
    xhrFields: {
      withCredentials: true
    }
  })
  .then(function(data, textStatus, jqXHR) {
    delete jqXHR.then;
    deferred.resolve(jqXHR);
  }, function(jqXHR) {
    delete jqXHR.then;
    deferred.reject(jqXHR);
  });
  return deferred;
}

module.exports = jqueryRequest;



/*****************
 ** WEBPACK FOOTER
 ** ./~/@okta/okta-auth-js/jquery/jqueryRequest.js
 ** module id = 515
 ** module chunks = 0
 **/